var _path, _mask, _g, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 29,
    viewBox: "0 0 17 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85523 28.4104C6.75368 28.4104 5.02741 27.6223 3.75148 26.0925C2.13779 24.1919 1.6124 21.1786 2.43801 18.8607C3.15103 16.8674 4.65214 15.6621 5.74044 14.7813L10.0561 11.3508C11.3696 10.2846 12.608 9.21835 12.8707 7.82763C13.1334 6.62233 12.608 5.18524 11.6323 4.3508C10.2062 3.14551 8.59254 3.37729 7.99209 3.56273C6.11571 4.07266 5.06494 5.78789 4.68967 6.48325L2.40048 4.62895C2.9634 3.56272 4.53956 1.01306 7.39165 0.224976C8.36737 -0.0531693 10.8817 -0.42403 13.1709 1.52299C15.0473 3.14551 15.9855 6.01968 15.4601 8.56935C14.9347 11.119 13.2084 12.6952 11.4822 14.0859L7.16649 17.5164C6.07819 18.3972 5.21505 19.1389 4.8773 20.1124C4.50203 21.1786 4.80225 22.6621 5.59033 23.6356C6.41594 24.6091 7.50423 25.0727 9.00534 25.0263C11.4071 24.9799 13.0958 22.9866 13.6963 22.1521L15.6853 24.3773C14.8221 25.5362 12.4954 28.2713 9.04287 28.364C9.00534 28.4104 8.93028 28.4104 8.85523 28.4104Z",
    fill: "#226C55"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 14,
    height: 29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.85523 28.4104C6.75368 28.4104 5.02741 27.6223 3.75148 26.0925C2.13779 24.1919 1.6124 21.1786 2.43801 18.8607C3.15103 16.8674 4.65214 15.6621 5.74044 14.7813L10.0561 11.3508C11.3696 10.2846 12.608 9.21835 12.8707 7.82763C13.1334 6.62233 12.608 5.18524 11.6323 4.3508C10.2062 3.14551 8.59254 3.37729 7.99209 3.56273C6.11571 4.07266 5.06494 5.78789 4.68967 6.48325L2.40048 4.62895C2.9634 3.56272 4.53956 1.01306 7.39165 0.224976C8.36737 -0.0531693 10.8817 -0.42403 13.1709 1.52299C15.0473 3.14551 15.9855 6.01968 15.4601 8.56935C14.9347 11.119 13.2084 12.6952 11.4822 14.0859L7.16649 17.5164C6.07819 18.3972 5.21505 19.1389 4.8773 20.1124C4.50203 21.1786 4.80225 22.6621 5.59033 23.6356C6.41594 24.6091 7.50423 25.0727 9.00534 25.0263C11.4071 24.9799 13.0958 22.9866 13.6963 22.1521L15.6853 24.3773C14.8221 25.5362 12.4954 28.2713 9.04287 28.364C9.00534 28.4104 8.93028 28.4104 8.85523 28.4104Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 12.5078,
    width: 16.8874,
    height: 3.70861,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.40625H0V12.8367H17V9.40625Z",
    fill: "#226C55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.0781H0V19.5086H17V16.0781Z",
    fill: "#226C55"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUa);
export default __webpack_public_path__ + "static/media/ua.28a9f2df.svg";
export { ForwardRef as ReactComponent };